import {IReduxServicesState} from '../../@interfaces';
import webSocketState from './websocket/state';

const state: IReduxServicesState = {
    websocket: webSocketState,
};

export default state;
